import { useLocation } from 'react-router-dom';
import { CurrentProductSelection } from './useCurrentProductFromRoute.types';

const useCurrentProductFromRoute = (): CurrentProductSelection => {
  const location = useLocation();
  const [firstSegment] = location.pathname.split('/').filter(Boolean);

  switch (firstSegment) {
    case 'workboard':
      return 'workboard';
    case 'firms':
      return 'portfolio-valuations';
    default:
      return null;
  }
};

export default useCurrentProductFromRoute;
